import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const INTEGRATIONS_HEADER_HEIGHT = 80

export const Container = styled(Box)`
  width: 100%;
  height: ${INTEGRATIONS_HEADER_HEIGHT}px;
  border-bottom: 1px solid ${theme.colors.borderMedium};
  background: ${theme.colors.surfaceContainerBackground};

  .integration-header-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 16px ${theme.spacing.medium}px;

    .back-arrow-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      html[data-theme='light'] & .MuiIconButton-root:hover {
        background: ${theme.colors.menuItemHover};
      }
    }

    .header-content {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: flex-start;
      width: 100%;

      .header-title {
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${theme.colors.menuItemText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 48px;
      }
    }

    .header-actions {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${theme.spacing.xSmall}px;

      .MuiButton-root {
        border-radius: ${theme.attributes.borderRadius.tertiary};
        color: ${theme.colors.surfaceContainerBackground};
        text-align: center;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large} !important;
        font-weight: ${theme.typography.fontWeight.bold} !important;
        line-height: 22px !important;
        font-style: normal !important;
        width: 200px;
        height: 48px;
        box-shadow: none !important;

        svg {
          path {
            fill: none;
          }
        }

        &.cancel-button {
          border: 1px solid ${theme.colors.borderMedium};
          color: ${theme.colors.menuItemText};

          &:hover {
            background: ${theme.colors.borderMedium};
            color: ${theme.colors.menuItemText};
            border-color: ${theme.colors.borderMedium};
          }

          &:focus,
          &:active {
            background: transparent;
            color: ${theme.colors.cta};
            border-color: ${theme.colors.cta};
          }

          &.Mui-disabled {
            background: transparent;
            color: ${theme.colors.btnSecondaryDisabledText};
            border-color: ${theme.colors.borderMedium};
            opacity: 1;

            html[data-theme='light'] & {
              color: ${theme.colors.menuItemText};
            }
          }
        }

        &.save-button {
          background: ${theme.colors.cta};
          color: ${theme.colors.surfaceContainerBackground};

          &:hover {
            background: ${theme.colors.buttonHollowHover};
            color: ${theme.colors.primaryDark};
          }

          &:focus,
          &:active {
            background: ${theme.colors.btnTertiaryBg};
            color: ${theme.colors.cta};
            border-color: ${theme.colors.btnTertiaryBg};
          }

          &.Mui-disabled {
            background: #946592 !important;
            color: ${theme.colors.surfaceContainerBackground} !important;
            opacity: 1 !important;

            /* Same grey disabled treatment as the shared primary button in light. */
            html[data-theme='light'] & {
              background: ${theme.colors.cardFillTertiary} !important;
              color: ${theme.colors.btnSecondaryDisabledText} !important;
            }
          }
        }
      }
    }
  }
`
